import { Row } from "@hightouch/htui";

import { COMPOSER_TEXT_INSET_PX } from "src/components/llm/components/compact-chat-input-layout";
import type { PageBrand } from "src/components/llm/agent-focus/agent-focus";
import { BrandLabel } from "src/pages/projects/components/brand-label";

const BRAND_LIST_FORMAT = new Intl.ListFormat("en", { type: "conjunction" });

type BrandScopePillProps = {
  /** The names of the brands the composer's options are limited to. */
  names: string[];
  /** The kind of page whose brand sets the scope; absent when the picks set it. */
  page?: PageBrand["page"];
};

/** A cue above the composer naming the brands its options are limited to, lined up with the composer's text. */
export function BrandScopePill({ names, page }: BrandScopePillProps) {
  const [only] = names;
  const label =
    names.length === 1 && only !== undefined ? only : `${names.length} brands`;
  const list = BRAND_LIST_FORMAT.format(names);
  return (
    <Row pl={`${COMPOSER_TEXT_INSET_PX}px`} textAlign="left">
      <BrandLabel
        label={label}
        tooltip={
          page
            ? `Options below are scoped to the ${page} brand.`
            : names.length === 1
              ? "Options below are scoped to your selection's brand."
              : `Options below are scoped to your selection's brands: ${list}.`
        }
      />
    </Row>
  );
}
